function trimTrailingSlashes(value: string): string {
  return value.replace(/\/+$/, '');
}

export function buildApiUrl(apiBaseUrl: string, path: string): string {
  return `${trimTrailingSlashes(apiBaseUrl)}/${path.replace(/^\/+/, '')}`;
}

export function isApiUrl(apiBaseUrl: string, url: string): boolean {
  const base = trimTrailingSlashes(apiBaseUrl);
  return url === base || url.startsWith(`${base}/`);
}
